import { useEffect, useState } from "react";
import { Stack } from "@fluentui/react";
import { Field, Textarea } from "@fluentui/react-components";

export const Resize = (props: any) => {
  console.log("1ddata=",props?.inputValue?.description);
  
  var isDisabled = props.disabled !== undefined ? props.disabled : false;
  const [value, setValue] = useState(props?.inputValue?.description ?? '');

  const handleInput = (data: any) => {
    setValue(data.target.value);
  };

  useEffect(() => {
    console.log("2ddata=",value);
    
    props.inputChange({...props?.inputValue, description: value});
  }, [value]);

  // useEffect(() => {
  //   setValue(props?.inputValue?.description);
  // }, [props?.inputValue.description])
  
  return (
    <Stack>
      <Field>
        <Textarea disabled={isDisabled} resize="both" value={value?.length > 0 ? value : props?.inputValue?.description} maxLength={300} size="small" onChange={handleInput} required={props.required}/>
      </Field>
    </Stack>
  );
};
